module.exports = __webpack_public_path__ + "static/media/Pic-0275.562cd108.jpg";